import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';

import { GuestComponent } from './guest.component';
import { CandidateProfileComponent } from './components/client/candidate-profile/candidate-profile.component';
import { BillingComponent } from './components/client/billing/billing.component';

import { GuestGuardService, AuthHttpService, BaseService }  from './services';
import { ExportService as ClientExportService } from './services/export/client/export.service';
import { ClientService }  from './services/client/client.service';

import { routing } from './guest.routing';
import { TimeService } from '../../shared/services/time.service';


export class GuestModule { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/guest/guest.module.ts